// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"8ac2e060","453":"f0ee6416","521":"b858b04f"}[chunkId] + ".chunk.js";
};